import styled from 'styled-components';
import { Container } from '@agilize/components-core';
import { device } from '@styles/tools/breakpoints.styles';
import { headerHeightDesktop, headerHeightMobile } from '@styles/trumps/utilities.styles';

export const ChildrenStyles = styled(Container)`
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  ${device.mobile} {
    max-width: 100vw;
  }
`;

export const ChildrenMain = styled(ChildrenStyles)`
  margin-top: ${headerHeightDesktop};

  ${device.mobile} {
    margin-top: ${headerHeightMobile};
  }
`;
